import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { useExtensionContext } from "../modules/extension/ExtensionContext";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useEtiketEkle = () => {
    const [etiketEkleLoading, setEtiketEkleLoading] = useState(false);
    const [error, setError] = useState(null);
    const { refetchEtiketList } = useExtensionContext();

    const etiketEkle = async ({ etiket, profil }) => {
        setEtiketEkleLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "etiketEkle",
                etiket,
                profil,
            });

            if (response?.data) {
                toast.success("Campaign added succesfully");
                refetchEtiketList();
            }

            return response;
        } catch (err) {
            toast.error(apiErrorText(err));
            setError(err);
            throw err;
        } finally {
            setEtiketEkleLoading(false);
        }
    };

    return { etiketEkleLoading, error, etiketEkle };
};

export default useEtiketEkle;
